import { Global, css, useTheme } from '@emotion/react';

export const GlobalStyle = () => {
  const theme = useTheme() as any;

  return (
    <Global
      styles={css`
        /* 스크롤바 전역 스타일 */
        ::-webkit-scrollbar {
          width: 6px;
        }

        ::-webkit-scrollbar-thumb {
          border-radius: 4px !important;
          background: ${theme.color.buttons.default} !important;
          border: 2px solid transparent;
          background-clip: padding-box;
        }

        ::-webkit-scrollbar-track {
          background: transparent;
        }

        html {
          /* Better Font Rendering =========== */
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          -webkit-tap-highlight-color: transparent;
          box-sizing: border-box;
          &:lang(en) {
            font-family: Poppins, sans-serif;
            line-height: 1.5;
          }
          &:lang(ko) {
            font-family: Pretendard, sans-serif;
            line-height: 1.5;
          }
        }

        .dds-icon {
          display: inline-flex;

          /* iOS WebKit: align-items:center 컨테이너 안에서 고유 크기 없는 svg가
           0×0으로 접혀 아이콘이 사라지는 문제 방지. inline-flex 기본 stretch와
           동일하게 svg를 항상 컨테이너 크기로 늘려 px 단위로 확정시킨다. */
          svg {
            align-self: stretch;
          }
        }

        *,
        *:before,
        *:after {
          box-sizing: inherit;
        }

        html,
        body {
          color: ${theme.color.mainFont};
          word-break: keep-all;
          /* 아이폰 이미지 저장 방지 */
        }

        .editor-bubble {
        }

        html:lang(ko-KR) body {
          font-family: Pretendard, sans-serif;
        }

        html:lang(ja) body {
          word-break: normal; /* CJK 기본 줄바꿈 규칙 사용 */
          line-break: strict; /* 일본어 금칙·줄바꿈 규칙(킨소쿠) 엄격 적용 */
        }

        /* 중국어(zh·zh-TW)도 일본어와 동일하게 CJK 기본 줄바꿈을 사용한다.
           띄어쓰기가 없어 keep-all이면 문장 전체가 한 덩어리가 되어 줄바꿈 지점이
           사라지고, 모달·카드 등 폭이 고정된 컨테이너 밖으로 텍스트가 넘친다.
           (특히 Safari는 문장부호에서도 줄바꿈을 허용하지 않아 한 줄로 삐져나감) */
        html:lang(zh) body {
          word-break: normal;
          line-break: strict;
        }

        html:lang(th) body {
          word-break: normal;
          overflow-wrap: break-word;
        }

        html,
        body,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        ol,
        ul,
        dl,
        dt,
        dd,
        button,
        input,
        pre {
          margin: 0;
          padding: 0;
        }

        body {
          #root {
            position: absolute;
            width: 100%;
          }
        }

        ol,
        ul {
          list-style: none;
        }

        a,
        a:hover {
          color: inherit;
          text-decoration: none;
          cursor: pointer;
        }

        button,
        [type='button'],
        [type='reset'],
        [type='submit'] {
          -webkit-appearance: button;
        }

        input[type='radio'] {
          -webkit-appearance: radio;
        }

        button {
          color: inherit;
          font-family: inherit;
          border: none;
          outline: none;
          background: none;
          cursor: pointer;
          &:disabled {
            cursor: not-allowed;
          }
        }

        input,
        textarea,
        select {
          font-family: inherit !important;
          border: 0;
          background: transparent;
          -webkit-appearance: none;
        }

        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          transition: background-color 5000s ease-in-out 0s;
          -webkit-transition: background-color 9999s ease-out;
          -webkit-box-shadow: 0 0 0px 1000px white inset !important;
          font-family: inherit !important;
        }

        input::-webkit-autofill::first-line {
          font-family: inherit !important;
          font-size: inherit !important;
        }

        // safari에서 disabled input, textarea text color 설정용
        input:disabled,
        textarea:disabled,
        input:disabled::placeholder,
        textarea:disabled::placeholder {
          -webkit-text-fill-color: #bcbcbc;
          opacity: 1;
        }

        img {
          -webkit-touch-callout: none;
          -webkit-user-select: none; /* iOS Safari */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none;
        }

        /* 드래그해서 저장 방지 (Firefox 는 user-drag 미지원이라 useImageSaveBlocker 가 이벤트로 차단).
           draggable="true" 는 의도된 드래그 소스라 제외한다 — 현재는 커뮤니티 글쓰기 첨부
           이미지 순서 변경(DraggedImageListBox)이 유일하다. 저장 차단(touch-callout·user-select)은
           이 이미지들에도 그대로 걸린다. */
        img:not([draggable='true']) {
          -webkit-user-drag: none;
        }

        .mt-20 {
          margin-top: 20px;
        }
        .mb-20 {
          margin-bottom: 20px;
        }

        .mb-30 {
          margin-bottom: 30px;
        }

        .ml-10 {
          margin-left: 10px;
        }

        .sub-font {
          color: ${theme.color.subfontgray};
        }

        .flex-center-center {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .ellipsis {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .ellipsis-two-line {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;

          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: wrap;
        }

        .drag-selectable {
          user-select: all;
          /* user-select: text; 경우 이미지 선택, cmd(ctl)+c 복사가 가능하므로 사용하지 않음.*/
        }

        .cursor-disabled {
          cursor: not-allowed !important;
        }
      `}
    />
  );
};
